// @ts-strict-ignore
import { ProjectOptionDefVO } from '@project/model/vo/project.vo';
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('UserOptionDefsVO')
export class UserOptionDefsVO {
  @JsonProperty('projectOptionDefs', '[ProjectOptionDefVO]')
  public projectOptionDefs: ProjectOptionDefVO[] = undefined;

  @JsonProperty('projectGroupOptionDefs', '[ProjectOptionDefVO]')
  public projectGroupOptionDefs: ProjectOptionDefVO[] = undefined;
}
